import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddCardDialogComponent } from '../add-card-dialog/add-card-dialog.component';
import { CommonFunctions } from 'src/app/shared/common-functions';
declare var dataLayer;
@Component({
  selector: 'app-card-remove-success',
  templateUrl: './card-remove-success.component.html',
  styleUrls: ['./card-remove-success.component.scss']
})
export class CardRemoveSuccessComponent implements OnInit {
  public userType: string;
  public userId: any;
  public tierType: any;
  public cardHolderName: any;
  public cardNO: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CardRemoveSuccessComponent>,
    public dialog: MatDialog,
    private router: Router,
    private commonFunction: CommonFunctions
  ) {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
    if(data.message == 'Card deleted successfully.'){
      this.cardHolderName=data.cardDetails.cardName ? data.cardDetails.cardName : data.cardDetails.cardTitle;
      this.cardNO = (data.cardDetails.shortCardNumber).toString();
    }
  }
  ngOnInit(): void {
  }
  //close function - closing the dialog
  close(){
    this.dialogRef.close('success');
    if(this.data.pageFrom == 'profileSetting'){
      this.router.navigate(['/profile/settings']);
    }else if(this.data.pageFrom == 'select-payment'){
    }else if(this.data.pageFrom == 'pastOrders' || this.data.pageFrom == 'global'){
      this.router.navigate(['/profile/help-center']); //navigate to profile module
    }else if(this.data.message == 'Card Added Successfully' || this.data.message == 'Balance transferred successfully'){
      this.router.navigate(['/pay/']); //navigate to pay module
    }else if(this.data.message == 'Card deleted successfully.'){
      this.router.navigate(['/pay/']); //navigate to pay module
    }else{
      this.router.navigate(['/manage-card']);//navigate to manage-card
    }
  }
  /**
 * Method to open the add new card dialog
 */
  public addNewCard() {
    this.close();
    const dialogRef = this.dialog.open(AddCardDialogComponent, {
      width: '744px',
      panelClass: "dialog-no-padding"
    });
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}